import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { GALLERY } from "@/i18n/content";
import { Reveal } from "@/components/site/Reveal";

function ParallaxImg({ src, className }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <div ref={ref} className={`overflow-hidden border border-black/10 ${className}`}>
      <motion.img
        style={{ y }}
        src={src}
        alt="Atlas Ziz Tours surf gallery"
        loading="lazy"
        className="w-full h-[120%] object-cover transition-transform duration-700 hover:scale-105"
      />
    </div>
  );
}

export default function Gallery() {
  const { t } = useLang();
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-cream py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="flex items-end justify-between mb-14">
          <div>
            <p className="label-mono text-ocean mb-6">{t.gallery.label}</p>
            <h2 className="font-outfit font-semibold text-4xl md:text-6xl tracking-tight text-ink">
              {t.gallery.title}
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <ParallaxImg src={g.src} className="aspect-[4/5]" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
